import React from 'react';
import { Box } from '@mui/material';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { Page } from '../../../../components';
import { SystemUserBulkUpload } from '../../../../components/system-user-bulk-upload';
import { RootState } from '../../../../store';

export const SystemUserBulkUploadScreen: React.FC = () => {
    const { authUser } = useSelector((state: RootState) => state.auth);

    if (authUser?.pomMaster && !authUser?.masquarade) {
        return <Navigate to="/system-users" replace />;
    }

    return (
        <Page title="POM - Upload System Users">
            <Box
                sx={{
                    mt: { lg: 'calc(-10vh - 24px)' },
                    mb: { lg: 'calc(-10vh - 24px)' },
                    pt: { lg: '10vh' },
                }}
            >
                <SystemUserBulkUpload />
            </Box>
        </Page>
    );
};
